module.exports = "/assets/data/7f50f1ce37a915e089e8b715d294deae-KA10.data.json";